export default "__VITE_ASSET__hvr2xhoy__"